import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/cardiology/coronarography";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	coronarography: {
		id: "ktx.coronarography.title",
		defaultMessage: "Coronarográfia"
	},
	result: {
		id: "ktx.coronarography.field.result",
		defaultMessage:
			"Eredmény (Kérjük amennyiben a terhelés vagy a DSE pozitív mindenképpen töltse ki az űrlapot)"
	},
	description: {
		id: "ktx.coronarography.field.description",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.description }] }
	]
};

export const node: LeafNode = {
	id: "ktx_coronarography",
	value: {
		schemaId: "coronarography",
		title: messages.coronarography,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
